import { general_button_download_reducers } from "../components/button/ButtonDownloadsrc/reducer";

const generalComponent = {
  general_button_download: general_button_download_reducers,
};

export default generalComponent;
